module.exports = __webpack_public_path__ + "static/BannerProducts-7a3e746e68d19899476c0bfaa46a142e.png";